$(document).ready(function() {

  if ($(".discounts-slider").length) {
    var $discountsSlider = $(".discounts-slider");
    var discountsSliderOptions = {
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" aria-label="More Discounts - Previous" class="prev-button"><img src="/wp-content/themes/good2go-2020/assets/images/green-link-arrow.png" alt="Previous Button" /></button>',
      nextArrow: '<button type="button" aria-label="More Discounts - Next" class="next-button"><img src="/wp-content/themes/good2go-2020/assets/images/green-link-arrow.png" alt="Next Button" /></button>',
      mobileFirst: true,
      infinite: false,
      responsive: [
        {
          breakpoint: breakpoints.small,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: breakpoints.xsmall,
          settings: "unslick"
        }
      ]
    };


    $discountsSlider.slick(discountsSliderOptions);

    $(window).resize(function () {
      if ($(window).width() > breakpoints.xsmall && !$discountsSlider.hasClass('slick-initialized')) {
        $discountsSlider.slick(discountsSliderOptions);
      }
    });
  }
});